export enum GAEvents {
  'CreateVacation' = 'create_vacation',
  'Login' = 'login',
}
